const getters = {
    tableDataGetter: state => state.dataAll,
    tableDataStatusPending: state => state.dataAll.allList.status.pending,
}

export default getters;